import { Component } from '@angular/core';
import { SkipUserComponentLibraryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'User Component Libraries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skipusercomponentlibrary-form',
    templateUrl: './skipusercomponentlibrary.form.component.html'
})
export class SkipUserComponentLibraryFormComponent extends BaseFormComponent {
    public record!: SkipUserComponentLibraryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

